// Manuals and Parts Page JavaScript
document.addEventListener('DOMContentLoaded', function () {
   'use strict';

   if ($(".sk-omp-list").length) {
      const manualsAndPartsContainer = $(".sk-omp-list").offset().top - $headerHeight;

      // Initialize the page
      initializeManualsPartsPage();

      function initializeManualsPartsPage() {
         // Initialize dropdown with collections
         populateCollectionsDropdown();

         // Set up event listeners
         setupEventListeners();
      }

      function populateCollectionsDropdown() {
         const dropdown = document.getElementById('js-omp-dropdown');
         const collectionsData = document.getElementById('manuals-collections-data');

         if (!dropdown || !collectionsData) return;

         try {
            const data = JSON.parse(collectionsData.textContent);

            // Remove loading option
            const loadingOption = dropdown.querySelector('option[value="loading"]');
            if (loadingOption) {
               loadingOption.remove();
            }

            const excludedHandles = [
               "all",
               "pwrcore-12",
               "pwrcore-20",
               "power-tools",
               "products",
               "pwrcore-40",
               "true-hvl"
            ];

            function decodeHTMLEntities(str) {
               const txt = document.createElement('textarea');
               txt.innerHTML = str;
               return txt.value;
            }

            const filteredSortedCollections = data.collections
               .filter(collection => !excludedHandles.includes(collection.handle))
               .sort((a, b) => a.title.localeCompare(b.title));

            // Add collection options
            filteredSortedCollections.forEach(collection => {
               const option = document.createElement('option');
               option.value = collection.handle;
               option.textContent = decodeHTMLEntities(collection.title);
               dropdown.appendChild(option);
            });
         } catch (e) {
            console.error('Error parsing collections data:', e);
         }
      }

      function setupEventListeners() {
         // Dropdown filter
         const dropdown = $("#js-omp-dropdown");
         if (dropdown) {
            dropdown.on('selectmenuchange', function () {
               filterManualsParts(this.value);
            });
         }

         // Search form submit
         const searchForm = document.getElementById('manuals-search-form');
         if (searchForm) {
            searchForm.addEventListener('submit', function (e) {
               e.preventDefault();
               const searchInput = document.getElementById('js-omp-search');
               if (searchInput) {
                  filterOwnerProducts(searchInput);
               }
            });
         }

         // Search input change
         const searchInput = document.getElementById('js-omp-search');
         if (searchInput) {
            searchInput.addEventListener('input', function () {
               if (this.value === '') {
                  filterOwnerProducts(this);
                  // Reset dropdown to "All Products"
                  if (dropdown) {
                     dropdown.val('all').selectmenu('refresh');
                  }
               }
            });
         }
      }

      function filterManualsParts(filter) {
         const items = document.querySelectorAll('.sk-omp-list__item');

         let activeItems = [];

         items.forEach(item => {
            item.classList.remove('active', 'first-active', 'last-active');

            if (filter === 'all' || item.classList.contains(filter)) {
               item.classList.add('active');
               activeItems.push(item);
            }
         });

         // Assign first-active and last-active
         if (activeItems.length > 0) {
            activeItems[0].classList.add('first-active');
            activeItems[activeItems.length - 1].classList.add('last-active');
         }

         // Clear search input when using dropdown
         const searchInput = document.getElementById('js-omp-search');
         if (searchInput) {
            searchInput.value = '';
         }

         smoothScrollToClass(manualsAndPartsContainer);
      }

      function filterOwnerProducts(searchInput) {
         const inputVal = searchInput.value.toLowerCase();
         const items = document.querySelectorAll('.sk-omp-list__item');

         let activeItems = [];

         items.forEach(item => {
            item.classList.remove('active', 'first-active', 'last-active');

            const productName = item.querySelector('.js-owners-product-name');
            const productModel = item.querySelector('.js-owners-product-model');

            if (!productName) return;

            const productNameText = productName.textContent.toLowerCase();
            const productModelText = productModel ? productModel.textContent.toLowerCase() : '';

            if (productNameText.includes(inputVal) || productModelText.includes(inputVal)) {
               item.classList.add('active');
               activeItems.push(item);
            }
         });

         // Assign first-active and last-active
         if (activeItems.length > 0) {
            activeItems[0].classList.add('first-active');
            activeItems[activeItems.length - 1].classList.add('last-active');
         }

         smoothScrollToClass(manualsAndPartsContainer);
      }
   }
}); 